import { useEffect, useState } from "react";
import { useApolloClient } from "@apollo/react-hooks";
import { GET_PARAMERTER_NAME_BY_ID, GET_CLIENT_PAREMETER_NAMES_BY_IDS } from "../CCCarbonMetal/components/CarbonMetalProcess/components/getStepDetail";

export const useGetParameterName = (paremeter_id) => {
  const client = useApolloClient();
  const [machineName, setMachineName] = useState("");
  useEffect(() => {
    const getParameterName = () => {
      client
        .query({
          query: GET_PARAMERTER_NAME_BY_ID,
          variables: {
            paremeter_id: paremeter_id,
          },
        })
        .then(({ data }) => {
          setMachineName(data?.getClientParemeterNameById);
        })
        .catch((error) => {
          console.log("Error: ", error);
        });
    };
    getParameterName();
  }, []);
  return machineName;
};

// Batch fetch parameter names by IDs
export const useGetParameterNamesByIds = (paremeter_ids) => {
  const client = useApolloClient();
  const [parameterNamesMap, setParameterNamesMap] = useState({});
  const [parameterNamesArray, setParameterNamesArray] = useState([]);

  useEffect(() => {
    if (!paremeter_ids || paremeter_ids.length === 0) {
      return;
    }

    // Filter out invalid IDs and ensure uniqueness
    const validIds = [...new Set(paremeter_ids.filter(id => id && !isNaN(id) && id > 0))];
    
    if (validIds.length === 0) {
      return;
    }

    const getParameterNames = () => {
      client
        .query({
          query: GET_CLIENT_PAREMETER_NAMES_BY_IDS,
          variables: { paremeter_ids: validIds },
        })
        .then(({ data }) => {
          const parameters = data?.getClientParemeterNamesByIds || [];
          // Create a map for easy lookup by paremeter_id
          const parameterMap = {};
          parameters.forEach(parameter => {
            if (parameter?.paremeter_id) {
              parameterMap[parameter.paremeter_id] = parameter.name;
            }
          });
          setParameterNamesMap(parameterMap);
          setParameterNamesArray(parameters);
        })
        .catch((error) => {
          console.log("Error fetching parameter names: ", error);
        });
    };
    getParameterNames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paremeter_ids?.join(',')]);

  return { parameterNamesMap, parameterNamesArray };
};
